import {
  type ProfileModuleDto,
  ProfileModuleType,
} from '@up2stay/up2promo-api-client';

export const MODULE_TYPE_LABELS: Array<{
  type: ProfileModuleType;
  label: string;
  description: string;
}> = [
  {
    type: ProfileModuleType.BIOGRAPHY,
    label: 'Biografie',
    description: 'Längerer Beschreibungstext über Person oder Firma',
  },
  {
    type: ProfileModuleType.CONTACT_INFO,
    label: 'Kontaktinfo',
    description: 'Telefonnummern und E-Mail-Adressen',
  },
  {
    type: ProfileModuleType.SOCIALS,
    label: 'Socials',
    description: 'Links zu Social-Media-Profilen (Instagram, LinkedIn, etc.)',
  },
  {
    type: ProfileModuleType.LINKS,
    label: 'Links',
    description:
      'Linkliste ähnlich Linktree (Titel, URL, optional Beschreibung)',
  },
  {
    type: ProfileModuleType.VIDEO,
    label: 'Video',
    description: 'Eingebettetes YouTube-Video',
  },
  {
    type: ProfileModuleType.IMAGES,
    label: 'Bilder',
    description: 'Bildergalerie oder Portfolio (Grid oder Slider)',
  },
  {
    type: ProfileModuleType.FILES,
    label: 'Dateien',
    description: 'Downloadbare Dateien (z. B. PDFs, Präsentationen)',
  },
  {
    type: ProfileModuleType.GOOGLE_MAPS,
    label: 'Standort',
    description: 'Kartenausschnitt für einen Standort',
  },
  {
    type: ProfileModuleType.TEAM_MEMBERS,
    label: 'Teammitglieder',
    description: 'Liste an Teammitgliedern (Name, Rolle, Bild)',
  },
];

export function getModuleLabel(type: ProfileModuleType): string {
  return MODULE_TYPE_LABELS.find((m) => m.type === type)?.label ?? type;
}

/** Default label for the "add module" dialog etc. */
export function getModuleDescription(type: ProfileModuleType): string {
  return MODULE_TYPE_LABELS.find((m) => m.type === type)?.description ?? '';
}

/**
 * Section heading for a module: custom title from config if set, otherwise fallback (e.g. module type label).
 */
export function getModuleSectionTitle(
  module: ProfileModuleDto,
  fallbackLabel: string,
): string {
  const custom = (module.config?.sectionTitle as string)?.trim();
  return custom || fallbackLabel;
}
